<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="panelDescription" [icon]="panelIcon">
    <form class="ng-untouched ng-pristine ng-valid" #formEditCompany="ngForm" novalidate>
      <div id="containerVacaciones" class="col-12">
        <dx-load-panel #loadPanel shadingColor="rgba(231, 231, 231,0.4)" [position]="{ of: '#containerVacaciones' }"
          [visible]="loading" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
        </dx-load-panel>

        <!-- Nueva solicitud -->
        <div class="row">
          <div class="col-sm-12 col-lg-8 m-auto mt-3 mb-3" style="margin-bottom: 20px;" *ngIf="showSearchPanel">

            <div class="col-md col-lg col-xl">
              <app-company-selector dataSize="7" placeHolder="Empresas" [(ngModel)]="selectedCompany"
                [required]="true" [onlyConfigured]="true"></app-company-selector>
            </div>

            <div class="col-md col-lg col-xl">
              <app-employee-selector [companyCode]="selectedCompany" placeHolder="Empleados"
                [(selectedValue)]="selectedEmployee" [required]="true"></app-employee-selector>
            </div>

            <div class="col-md col-lg col-xl">
              <app-year-selector dataSize="7" placeHolder="Ejercicio" [required]="true"
                [(selectedValue)]="selectedYear">
              </app-year-selector>
            </div>
            <!-- Botón de búsqueda -->
            <div class="col-md-auto col-lg-auto col-xl-auto">
              <button class="btn btn-fill btn-primary float-right" (click)="onButtonBuscarClick()">Buscar</button>
            </div>
          </div>

          <!-- Modo edición -->
          <div class="col-sm-12 col-lg-8 m-auto mt-3 mb-3 row" style="margin-bottom: 20px;" *ngIf="!showSearchPanel">

            <div class="col-md col-lg col-xl">
              <mat-form-field>
                <input matInput type="text" name="DescripcionEmpresa" placeholder="Empresa" [ngModel]="
                  periodoVacaciones && periodoVacaciones.DescripcionEmpresa
                    " readonly />
              </mat-form-field>
            </div>

            <div class="col-md col-lg col-xl">
              <mat-form-field>
                <input matInput type="text" name="NombreTrabajador" placeholder="Trabajador" [ngModel]="
                  periodoVacaciones && periodoVacaciones.NombreTrabajador
                    " readonly />
              </mat-form-field>
            </div>

            <div class="col-md col-lg col-xl">
              <mat-form-field>
                <input matInput type="text" name="Ejercicio" placeholder="Ejercicio" [ngModel]="
                  periodoVacaciones && periodoVacaciones.Ejercicio
                    " readonly />
              </mat-form-field>
            </div>
          </div>
        </div>



        <div class="row">
          <div class="row col-sm-12 col-lg-8 m-auto">
            <div class="col-md col-lg col-xl">
              <mat-form-field>
                <input matInput type="text" name="Convenio" placeholder="Convenio" [ngModel]="
                periodoVacaciones && periodoVacaciones.NombreConvenio" readonly />
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="row">

          <div class="col-sm-12 col-lg-4 ml-auto mt-3 mb-3">

            <legend>Días</legend>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasPorConvenio" placeholder="Por convenio" [(ngModel)]="
                periodoVacaciones && periodoVacaciones.DiasPorConvenio
                  " class="textAlignRight" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="CompensacionFestivos" placeholder="Compensación Festivos" [(ngModel)]="
                periodoVacaciones && periodoVacaciones.CompensacionFestivos
                  " class="textAlignRight" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Otros" placeholder="Ajuste" [(ngModel)]="otros" class="textAlignRight" style="padding-right: 5px;" />
                <button matSuffix mat-button (click)="onButtonActualizarClick()">Actualizar</button>
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasPasadoEjercicio" placeholder="Vacaciones años anteriores"
                  [(ngModel)]="
                periodoVacaciones && periodoVacaciones.DiasPasadoEjercicio
                  " class="textAlignRight" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Suma" placeholder="Suma" [(ngModel)]="
                periodoVacaciones &&
                periodoVacaciones.Suma
                " class="textAlignRight" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="DiasDisfrutados" placeholder="Días solicitados/Realizados" [(ngModel)]="
                periodoVacaciones && periodoVacaciones.DiasDisfrutados
                  " class="textAlignRight" readonly />
              </mat-form-field>
            </div>
            <div class="col-12">
              <mat-form-field>
                <input matInput type="text" name="Total" placeholder="Total"
                  [(ngModel)]="periodoVacaciones && periodoVacaciones.Total" class="textAlignRight" readonly />
              </mat-form-field>
            </div>

          </div>
          <div class="col-sm-12 col-lg-4 mr-auto mt-3 mb-3">
            <form class="ng-untouched ng-pristine ng-valid" #formGenerarSolicitud="ngForm">
              <legend>Periodos de vacaciones</legend>
              <dx-data-grid id="gridContainer" [dataSource]="solicitudes">
                <dxo-search-panel [visible]="false"></dxo-search-panel>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-column-chooser [enabled]="false"></dxo-column-chooser>
                <!-- Definición de las columnas -->
                <dxi-column dataField="FechaInicio" caption="Inicio" dataType="date" alignment="right"
                  format="dd/MM/yyyy">
                </dxi-column>
                <dxi-column dataField="FechaFin" caption="Fin" dataType="date" alignment="right" format="dd/MM/yyyy">
                </dxi-column>
                <dxi-column dataField="Dias" caption="Días" alignment="center"> </dxi-column>
              </dx-data-grid>
            </form>
          </div>
        </div>
      </div>
    </form>
    <!-- Botonera -->
    <div class="row">
      <div class="col-md-12">
        <div class="form-group form-button">
          <a class="btn btn-fill btn-outline-white float-right" (click)="goBack()">Volver</a>
        </div>
      </div>
    </div>
  </app-generic-panel>
</app-generic-container>
